import React from 'react';

import { Button, Group, Title, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons-react';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';

import AppointmentTypeTableContainer from './components/AppointmentTypeTableContainer';
import DrawerAppointmentTypeForm from './components/DrawerAppointmentTypeForm';

const AppointmentType = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const appointmentPerm = hasPerm('EventTypeLocationMutate');
  const [createFormOpened, { open: openCreateForm, close: closeCreateForm }] = useDisclosure(false);

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Appointment Type
          </Title>
          <Button
            leftIcon={<IconPlus size={theme.fontSizes.md} />}
            onClick={openCreateForm}
            disabled={!appointmentPerm}
            data-cy='createAppointmentButton'
          >
            Appointment Type
          </Button>
        </Group>
      </PageHeader>

      <AppointmentTypeTableContainer permission={appointmentPerm} />
      <DrawerAppointmentTypeForm
        type='create'
        formId='create-appointment-type-form'
        title={<Title order={3}>Create Appointment Type</Title>}
        opened={createFormOpened}
        closeHandler={closeCreateForm}
      />
    </>
  );
};

export default AppointmentType;
